import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'asset'
})
export class AssetPipe implements PipeTransform {
  transform(url: string): string {
    // Якщо URL порожній або не визначений, повертаємо порожній рядок
    if (!url) return '';

    // Якщо посилання вже є абсолютним (починається з http/https), повертаємо його без змін
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/')) {
      return url;
    }

    // Для відносних шляхів (на кшталт 'assets/img/...') додаємо префікс
    const prefix = (window as any).configuratorPrefix || '';

    return prefix + url;
  }
}
